import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'

import PrevArrow from './PrevArrow'
import NextArrow from './NextArrow'
import HoverLink from './styled/HoverLink'

import persons from '../persons.js'

const Component = React.createClass({
  render: function() {
    const prev = persons[this.props.previous]
    const next = persons[this.props.next]

    const linkStyle = {
      fontSize: '1.3rem',
      textDecoration: 'none',
      fontFamily: 'Oswald, sans-serif'
    }

    return (<div>
      <HoverLink style={{...linkStyle, color: prev.color}} to={prefixLink(prev.path)}><PrevArrow style={{color: '#222222'}} /> {prev.name}</HoverLink>
      <HoverLink style={{...linkStyle, float: 'right', color: next.color}} to={prefixLink(next.path)}>{next.name} <NextArrow style={{color: '#222222'}} /></HoverLink>
    </div>)
  }
})

export default Component



// WEBPACK FOOTER //
// ../components/PageNav.js